import { render, staticRenderFns } from "./form-inativar.vue?vue&type=template&id=c7915e24"
import script from "./form-inativar.vue?vue&type=script&lang=js"
export * from "./form-inativar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports